import {CHARTKIT_WIDGET_TYPE} from '../ChartKit/components/Widget/Widget';
import {Table} from '../ChartKit/components/Widget/components/Table/Table';

export default {
    key: CHARTKIT_WIDGET_TYPE.TABLE,
    value: Table,
};
